import React from 'react';
import { ChevronDown, ChevronUp } from 'src/common/Chevron';
import * as S from './GTSort.styles';

interface GTSortProps {
  isSorted: boolean;
  isAsc: boolean;
}

export const GTSort: React.FC<GTSortProps> = ({ isSorted, isAsc }) => {
  return (
    <S.Div>
      <ChevronUp active={isSorted && isAsc} />
      <ChevronDown active={isSorted && !isAsc} />
    </S.Div>
  );
};
